import { useNow } from "../hooks/useNow";
import { programmeringByMin } from "../lib/data";
import { minutesNow } from "../lib/time";

export function Upcoming() {
  const now = useNow(30_000);
  const nowMin = minutesNow(now);

  const window = programmeringByMin.filter(
    (p) =>
      p.vanMin != null &&
      p.vanMin > nowMin &&
      p.vanMin <= nowMin + 90 &&
      !p.is_overleg,
  );

  if (window.length === 0) {
    return (
      <div className="text-2xs text-zinc-500 px-1">
        — niets in de komende 90 min —
      </div>
    );
  }

  return (
    <ul className="space-y-1.5">
      {window.map((p) => (
        <li
          key={p.id}
          className={`card p-2.5 flex items-start gap-3 ${p.has_aandacht ? "border-warn/40" : ""}`}
        >
          <div className="w-12 shrink-0 text-sm font-mono tabular text-zinc-300">
            {p.tijd_van}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-zinc-100 truncate">
              {p.has_aandacht && <span className="text-warn mr-1">⚠</span>}
              {p.wat}
            </div>
            <div className="text-2xs text-zinc-500 truncate">
              {p.locatie.venue}
              {p.locatie.stage ? ` · ${p.locatie.stage}` : ""}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
